module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"close":"Close","date":"Date","open":"Open","recipient":"Recipient","sent":"Sent","sentNot":"Not sent","status":"Status","subject":"Subject"}}')
  delete Component.options._Ctor
}
